export enum SurveyAction {
    View = 1,
    GetPDF = 2,
    MarkAppointmentBooked = 3,
    MarkComplete = 4,
    FollowUpUnsuccessful = 5, // mark-incomplete
    UploadRequisition = 6,
    RequisionAlreadySent = 7,
    PhoneInterviewSurvey = 8,
    ResendSurveyEmail = 9
}